import { render } from "./Live.vue?vue&type=template&id=0e72df12&scoped=true"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"

import "./Live.vue?vue&type=style&index=0&id=0e72df12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e72df12"]])

export default __exports__